<template>
  <v-layout column style="overflow-y: scroll; height: calc(100vh - 76px);">
    <v-toolbar dark class="toolbarcreatedadmin nonPrint" style="margin-top: 10px;">
      <v-btn icon @click="routeinfo()">
        <v-icon>fas fa-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title>รายละเอียดปัญหา</v-toolbar-title>
    </v-toolbar>
    <div style="height: calc(100vh - 140px);">
    <v-layout row wrap justify-end style="margin-top: 0px;" class="nonPrint">
      <div class="nonPrint positionPrint" >
        <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn class="ma-2" outlined fab small color="#a80f00" style="" @click="gotoAED()" v-on="on">
            <v-icon> fas fa-heartbeat</v-icon>
          </v-btn>
        </template>
        <span class="nonPrint">ข้อมูล AED</span>
      </v-tooltip> 
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn class="ma-2" outlined fab small color="#a80f00" @click="print()" v-on="on">
        <img :src="BASE_URL + 'static/iconButton/printing.png'" alt="" width="25px">
      </v-btn>
        </template>
        <span class="nonPrint">Print</span>
      </v-tooltip>   
  </div>
    </v-layout>
    <v-layout column wrap justify-center align-center class="nonPrint">
      <v-layout wrap justify-center align-center class="border-images" v-if="data_issue.issue_picture.length !== 0">
          <v-carousel
      cycle
      height="200"
      hide-delimiter-background
      show-arrows-on-hover
    >
      <v-carousel-item v-for="slide in data_issue.issue_picture">
            <img :src="API_BACKEND + '/v1/thumbnail' + slide.picture_path" height="200">
          </v-carousel-item>
        </v-carousel>
      </v-layout>
      <v-layout row wrap style="max-width: 600px;">
      <v-flex xs12 sm12 md12 lg12 xl12>
        <h2>{{data_issue.address_name}}</h2>
      </v-flex>
      <v-flex xs12 sm12 md12 lg12 xl12 v-if="data_issue.address_detail">
        <div style="text-align: left; background: #e2e2e2 !important; border-radius: 6px;padding: 10px;">
          <span>{{data_issue.address_detail}}</span>
        </div>
      </v-flex>
    </v-layout>


      <v-layout row wrap style="padding: 10px; margin-top: 5px; max-width: 600px;">
        <v-flex xs12 sm12 md12 lg12 xl12 style="text-align: left">
          <h3>ข้อมูลการแจ้ง</h3>
        </v-flex>
      <v-flex xs12 sm12 md12 lg12 xl12 >
         <div style="text-align: left; background: #e6e6e657 !important; border-radius: 6px;padding: 10px; margin-bottom: 10px;">
      <p style="margin: 0; font-size: 14px; color: #7b7b7b;">จากคุณ {{data_issue.who_ask_issue}}</p>
      <span>{{data_issue.issue_detail}}</span>
      <p style="text-align: right;margin: 0;font-size: 14px; color: #7b7b7b;">
        {{ momentdatethai(data_issue.create_at)}} เวลา {{ momenttimethai(data_issue.create_at)}}น.
      </p>
    </div>
      </v-flex>

          <v-flex xs12 sm12 md12 lg12 xl12 style="text-align: left;">
          <p v-if="data_issue.who_confirm"><b>ผู้ยืนยันปัญหา:</b> {{data_issue.who_confirm}} <span style="color: #989898;">({{ momentdatethai(data_issue.confirm_at)}} เวลา {{ momenttimethai(data_issue.confirm_at)}}น.)</span></p>
          <p v-if="data_issue.issue_status == 'open'"><b>สถานะ:</b> รอการยืนยันปัญหา </p>
          <p v-else-if="data_issue.issue_status == 'confirm'"><b>สถานะ:</b> รอการแก้ไข </p>
          <p v-else-if="data_issue.issue_status == 'waiting_fix_confirm'"><b>สถานะ:</b> รอการยืนยันการแก้ไข</p>
          <p v-else-if="data_issue.issue_status == 'close'"><b>สถานะ:</b> ได้รับการแก้ไขแล้ว </p>
          <h3 v-else><b>สถานะ:</b> - </h3>
        </v-flex>




        <v-flex xs12 sm12 md12 lg12 xl12 style="text-align: left;" v-if="data_issue.issue_status == 'close' || data_issue.issue_status == 'waiting_fix_confirm'">
          <h3>ข้อมูลการซ่อมบำรุง</h3>
        </v-flex>
      <v-flex xs12 sm12 md12 lg12 xl12 v-if="data_issue.issue_status == 'close' || data_issue.issue_status == 'waiting_fix_confirm'">
         <div style="text-align: left; background: #e6e6e657 !important; border-radius: 6px;padding: 10px; margin-bottom: 10px;">
      <p style="margin: 0; font-size: 14px; color: #7b7b7b;">จากคุณ {{data_issue.who_fix}} <span v-if="data_issue.company_fix_name">({{data_issue.company_fix_name}})</span></p>
      <span>{{data_issue.maintenance_detail? data_issue.maintenance_detail: '-'}}</span>
      <p style="text-align: right;margin: 0;font-size: 14px; color: #7b7b7b;">
        {{ momentdatethai(data_issue.fix_at)}} เวลา {{ momenttimethai(data_issue.fix_at)}}น.
      </p>
    </div>
      </v-flex>



      <v-flex xs12 sm12 md12 lg12 xl12 v-if="((data_issue.company_name == nameCompany && typeCompany == 'partner') || typeCompany == 'owner') && data_issue.issue_status == 'confirm'">
         <div style="text-align: left; background: #e6e6e657 !important; border-radius: 6px;padding: 10px; margin-bottom: 10px;">
      <p style="margin: 0; font-size: 14px; color: #7b7b7b;">จาก คุณ</p>
     <!-- <v-text-field label="Outlined" hide-details outlined v-model="maintenance_detail"></v-text-field> -->
      <v-textarea
            hide-details
            no-resize
            rows="3"
            v-model="maintenance_detail"
          ></v-textarea>
      <!-- <span>{{data_issue.maintenance_detail? data_issue.maintenance_detail: '-'}}</span> -->
     <!--  <p style="text-align: right;margin: 0;font-size: 14px; color: #7b7b7b;">
        {{ momentdatethai(data_issue.fix_at)}} เวลา {{ momenttimethai(data_issue.fix_at)}}น.
      </p> -->
    </div>
      </v-flex>

    </v-layout>
<!-- {{authen}} -->

<div style="margin-bottom: 10px;">
<v-btn rounded style="background-color: white;
    border: #a80f00 solid;
    box-shadow: none;
    margin-top: 10px;
    text-transform: none;
    color: #a80f00;" v-if="((data_issue.company_name == nameCompany && typeCompany == 'partner') || typeCompany == 'owner') && data_issue.issue_status == 'waiting_fix_confirm'" @click="changeStatusIssue('reject')">
  <span>ปฎิเสธการแก้ไข</span>
</v-btn>

<v-btn rounded color="#a80f00" style="margin-top: 10px;text-transform: none; color: white;box-shadow: none;" v-if="((data_issue.company_name == nameCompany && typeCompany == 'partner') || typeCompany == 'owner') && data_issue.issue_status != 'close'" @click="changeStatusIssue(data_issue.issue_status)">
  <span v-if="data_issue.issue_status == 'open'">ยืนยันปัญหา</span>
  <span v-else-if="data_issue.issue_status == 'confirm'">ยืนยันการแก้ไข</span>
  <span v-else-if="data_issue.issue_status == 'waiting_fix_confirm'">ยืนยันการแก้ไข</span>
</v-btn>
</div>


  </v-layout>
</div>

  <!-- pdf -->
  <div class="pdfSection" style="margin-top: 30px;">
      <div>
      <div class="pageBreak" style="justify-content: center; display: grid;">

        <p style="margin-top: 30px;font-weight: bold;font-size: 30px">ข้อมูลเครื่อง AED</p>
       <div style="margin-top: 20px;">
  <img v-for="slide in data_issue.issue_picture" :src="API_BACKEND + '/v1' + slide.picture_path" height="200" style="margin-right: 10px;">
  </div>

  <!-- <h1>{{data_issue.address_name}}</h1> -->
<h2 style="text-align: left;">ข้อมูลเครื่องAED</h2>
<table class="customers" style="width: 600px;" v-if="data_issue">
      <tr>
        <th class="div_infor_header">เครื่องAED:</th>
        <td class="div_infor">{{data_issue.address_name}}</td>
      </tr>
      <tr>
        <th class="div_infor_header">รายละเอียดที่ตั้งเครื่อง AED:</th>
        <td class="div_infor">{{data_issue.address_detail}}</td>
      </tr>
      <tr>
        <th class="div_infor_header">บริษัทเจ้าของเครื่อง:</th>
        <td class="div_infor">
          {{data_issue.company_name? data_issue.company_name: '-'}}
          <v-chip class="ma-2" x-small >
            {{data_issue.company_type !=='owner'? data_issue.company_type: 'สภากาชาดไทย'}}
          </v-chip>
        </td>
      </tr>
</table>

<h2 style="text-align: left;margin-top: 10px;">ข้อมูลการแจ้ง</h2>
<table class="customers" style="width: 600px;" v-if="data_issue">
      <tr>
        <th class="div_infor_header">ผู้ที่แจ้งปัญหา:</th>
        <td class="div_infor">{{data_issue.who_ask_issue}}</td>
      </tr>
      <tr>
        <th class="div_infor_header">รายละเอียดปัญหา:</th>
        <td class="div_infor">{{data_issue.issue_detail}}</td>
      </tr>

      <tr>
        <th class="div_infor_header">วัน เวลาที่แจ้ง</th>
        <td class="div_infor">{{ momentdatethai(data_issue.create_at)}} เวลา {{ momenttimethai(data_issue.create_at)}}น.</td>
      </tr>
            <tr>
        <th class="div_infor_header">สถานะ:</th>
        <td class="div_infor" v-if="data_issue.issue_status == 'open'">รอการยืนยันปัญหา</td>
        <td class="div_infor" v-else-if="data_issue.issue_status == 'confirm'">รอการแก้ไข</td>
        <td class="div_infor" v-else-if="data_issue.issue_status == 'waiting_fix_confirm'">รอการยืนยันการแก้ไข</td>
        <td class="div_infor" v-else-if="data_issue.issue_status == 'close'">ได้รับการแก้ไขแล้ว</td>
        <td class="div_infor" v-else> - </td>
      </tr>
</table>

<h2 style="text-align: left;margin-top: 10px;" v-if="data_issue.issue_status == 'close' || data_issue.issue_status == 'waiting_fix_confirm'">ข้อมูลการแก้ไข</h2>
<table class="customers" style="width: 600px;" v-if="data_issue.issue_status == 'close'|| data_issue.issue_status == 'waiting_fix_confirm'">
      <tr>
        <th class="div_infor_header">ผู้ที่ทำการแก้ไข:</th>
        <td class="div_infor">{{data_issue.who_fix}}</td>
      </tr>
      <tr>
        <th class="div_infor_header">รายละเอียดการแก้ไข:</th>
        <td class="div_infor">{{data_issue.maintenance_detail}}</td>
      </tr>

      <tr>
        <th class="div_infor_header">วัน เวลาที่แจ้ง</th>
        <td class="div_infor">{{ momentdatethai(data_issue.fix_at)}} เวลา{{ momenttimethai(data_issue.fix_at)}}น.</td>
      </tr>
</table>



     </div> 
   </div>
   </div>


  </v-layout>
</template>
<script>
import Vue from 'vue'
import ImageSlider from '@gaiaz/vue-image-slider'
import '@gaiaz/vue-image-slider/dist/image-slider.css'
import { Carousel, Slide } from 'vue-carousel'
import { Decode, Momenttime } from '@/services'
var _ = require('lodash')
var moment = require('moment')
export default {
  data () {
    return {
    BASE_URL: process.env.BASE_URL,
    API_BACKEND: process.env.API_BACKEND,
    issue_id: '',
    authen: {},
    headerAPI: '',
    typeCompany: '',
    nameCompany: '',
    maintenance_detail: '',
    data_issue: {}
  }},
  components: {
    Carousel,
    Slide
  },
  created () {
    var decode = Decode.decode(localStorage.getItem('key'))
    this.authen = JSON.parse(decode)
    this.typeCompany = this.authen.typeCompany
    this.nameCompany = this.authen.nameCompany
    this.headerAPI = {Authorization: this.authen.Authorization}
    this.issue_id = this.$route.query.id
    this.getData()
  },
  mounted () {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    gotoAED () {
      this.$router.push('/information_aed?id=' + this.data_issue.aed_id)
    },
    print () {
      window.print()
    },
    routeinfo () {
      this.$router.back()
    },
    momentdatethai(data) {
      return Momenttime.momentdatethai(data)
    },
    momenttimethai(data) {
      return Momenttime.momenttimethai(data)
    },
    getData () {
      var body = {
        issue_id: this.issue_id
      }
      this.axios.post(process.env.API_BACKEND + '/v1/getIssueDetailByIssueID', body, {headers: this.headerAPI}).then((response) => {
        this.data_issue = response.data.data
      })
    },
    changeStatusIssue (status) {
      if (status == 'open') {
        this.conformIssue()
      } else if (status == 'confirm') {
        this.closeIssue()
      } else if (status == 'waiting_fix_confirm') {
        // console.log('ยืนยัน')
        this.closeIssue_confirmMaintenance()
      } else if (status == 'reject') {
        // console.log('reject')
        this.closeIssue_rejectMaintenance()
      }
    },
    conformIssue () {
      var body = {
        issue_id: this.issue_id
      }
      this.axios.post(process.env.API_BACKEND + '/v1/confirmIssueAED', body, {headers: this.headerAPI}).then((response) => {
        this.data_issue.issue_status = 'confirm'
      })
    },
    closeIssue () {
      var body = {
        issue_id: this.issue_id,
        maintenance_detail: this.maintenance_detail
      }
      this.$swal({
        title: 'คุณยืนยันการแก้ไขปัญหานี้ใช่หรือไม่',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ยกเลิก',
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.API_BACKEND + '/v2/closeIssueAED', body, {headers: this.headerAPI}).then((response) => {
            // console.log(response.data)
            this.data_issue.issue_status = 'close'
            this.data_issue.fix_at = response.data.fix_at
            this.data_issue.fix_by = response.data.fix_by
            this.data_issue.who_fix = 'คุณ'
            this.data_issue.company_fix_name = ''
            this.data_issue.maintenance_detail = this.maintenance_detail
          })
        }
      })
      
    },
    closeIssue_confirmMaintenance () {
      var body = {
        issue_id: this.issue_id,
        isConfirm: "true"
      }
      this.$swal({
        title: 'คุณยืนยันการแก้ไขปัญหานี้ใช่หรือไม่',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ยกเลิก',
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.API_BACKEND + '/v2/confirmCloseIssueAED', body, {headers: this.headerAPI}).then((response) => {
            console.log(response.data)
            this.data_issue.issue_status = 'close'
          })
        }
      })
    },
    closeIssue_rejectMaintenance () {
      var body = {
        issue_id: this.issue_id,
        isConfirm: "false"
      }
      this.$swal({
        title: 'ปัญหานี้ยังไม่ได้รับการแก้ไขใช่หรือไม่',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ยกเลิก',
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.API_BACKEND + '/v2/confirmCloseIssueAED', body, {headers: this.headerAPI}).then((response) => {
            console.log(response.data)
            this.data_issue.issue_status = 'confirm'
          })
        }
      })
      
    }
  }
}
</script>
<style media="screen" scoped>
  .fonts {
    font-family: 'Sarabun', sans-serif !important;
  }
  .positionPrint {
    width: 70vw;
    margin-left: 30vw;
    text-align: right;
    padding-right: 16vw;
  }

   .customers {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
}

.customers td, .customers th {
  border: 1px solid #ddd;
  padding: 8px;
}


.customers th {
  background-color: #a80d00;
  color: white;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 10px;
  /*text-align: right !important;*/
}
.customers td {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 10px;
  text-align: left !important;
  width: 400px;
}

  @media screen {
    #PDF {
      height: 60vh !important;
      overflow: scroll;
    }
    .pdfSection {
      display: none;
    }
  }
  @media print {
    .pdfSection {
      display: show;
      -webkit-print-color-adjust: exact; 
    }
    .nonPrint {
      display: none;
    }
    #PDF {
      height: auto;
      overflow: hidden;
    }
    .pageBreak { page-break-inside:always; }
    .pageBreak * {
      page-break-after:avoid;
      page-break-before:avoid;
    }
  }
  >>>.material-icons {
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 33px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;
  }
  .fonts-icons {
    font-size: 55px !important;
  }
  .border-images {
    border-color: #a80e00 !important;
    border-style: solid !important;
    width: 450px !important;
    border-radius: 20px !important;
    margin-bottom: 20px !important;
  }
  >>>.accent {
    background-color: #8c0c00 !important;
  }

  .div_infor_button {
    height: 40px !important;
    width: 400px !important;
    margin-top: 30px !important;
    justify-content: center !important;
    display: flex !important;
    align-items: center !important;
    font-size: 18px !important;
  }
  .div_infor_button_help {
    background-color: white !important;
    height: 40px !important;
    width: 100% !important;
    margin-top: 30px !important;
    justify-content: center !important;
    display: flex !important;
    align-items: center !important;
    font-size: 18px !important;
  }
  >>>.white {
    width: 100% !important;
    background-color: #fff!important;
    border-color: #fff!important;
  }
  >>>.theme--dark.v-text-field--solo>.v-input__control>.v-input__slot {
    border-radius: 30px;
    background: #ffffff;
    color: #a80e00;
    border-color: #a80e00;
    border-style: solid;
    border-width: thin;
  }
  .inputinfor_address {
    height: 110px !important;
    border-width: thin !important;
    border-style: solid !important;
    border-color: #a80e00 !important;
    border-radius: 7px !important;
    background-color: white !important;
  }
  .inputinfor {
    height: 50px !important;
    border-width: thin !important;
    border-style: solid !important;
    border-color: #a80e00 !important;
    border-radius: 7px !important;
    background-color: white !important;
  }
  .inputinfor_dis {
    height: 50px !important;
    border-width: thin !important;
    border-style: solid !important;
    border-color: #a80e00 !important;
    border-radius: 7px !important;
    background-color: #FAF0F0 !important;
  }
  >>>.theme--dark.v-select .v-select__selections {
      color: #a80e00 !important;
  }
  >>>.theme--dark.v-label {
      color: hsl(5, 100%, 33%) !important;
  }
  >>>.theme--dark.v-icon {
      color: #a80e00 !important;
  }
  >>>.theme--dark.v-input:not(.v-input--is-disabled) input {
    color: #a80e00 !important;
  }
  .toolbarcreatedadmin {
    border-top-color: transparent !important;
    border-left-color: transparent !important;
    border-width: thin !important;
    border-right-color: transparent !important;
    border-style: solid !important;
    height: 64px !important;
    border-left-style: initial !important;
    border-right-style: initial !important;
    border-radius: 0px !important;
    border-bottom-color: #a80e00 !important;
    background-color: white !important;
    color: #a80e00 !important;
    border-width: thin !important;
    box-shadow: none !important;
  }
  .btngen {
    background-color: white !important;
    color: #a80f00 !important;
    border-color: #a80f00 !important;
    border-style: solid !important;
    border-width: thin !important;
    text-transform: none !important;
    width: 120px !important;
  }
  .btncreateuser {
    background-color: #a80f00 !important;
    color: #fafafa !important;
    border-color: #a80f00 !important;
    border-style: solid !important;
    border-width: thin !important;
    text-transform: none !important;
  }
  .btncreateuser:disabled {
    background-color: #a80f0099 !important;
    color: #fafafa9c !important;
    border-color: #a80f0091 !important;
    border-style: solid !important;
    border-width: thin !important;
  }

  .btncancle {
    background-color: #fafafa !important;
    color: #a80f00 !important;
    border-color: #a80f00 !important;
    border-style: solid !important;
    border-width: thin !important;
    width: 160px !important;
  }

  .div_infor_header {
    background: rgb(168, 14, 0) !important;
    color: white;
    text-align: right;
    padding-right: 10px;
    font-size: 15px;
    padding-right: 10px;
    border: 1px solid #a80d00 !important;
  }
  .div_infor {
    width: 20vw;
    /*border: solid 1px #a80d00;*/
    text-align: left;
    font-size: 15px;
    padding-left: 10px;
    border: 1px solid #a80d00 !important;
  }

  .tableInfor {
    justify-content: center;
    display: inline-table;
    width: 40vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/information_print/infor_issue.vue